import { SwapMode } from '../common/types/index.js';
export const serializeQuoteKey = (params) => {
    const { pairId, amount, slippage = 0, fromAddress = '', swapMode = SwapMode.ExactIn } = params;
    return `${pairId}-${amount.toDefaultString()}-${slippage}-${fromAddress}-${swapMode}`;
};
const extractErrorDetails = async (error) => {
    const status = error.response.status;
    const statusText = error.response.statusText;
    const errorData = await error.response.json().catch(() => ({}));
    let errorDetails = errorData.error || errorData.details || errorData.message;
    if (!errorDetails) {
        errorDetails = Object.values(errorData).join(', ');
    }
    return { status, statusText, errorDetails, errorData };
};
export const parseFetchivalError = async (error) => {
    if (error.response) {
        const { status, statusText, errorDetails } = await extractErrorDetails(error);
        return `${status}:${statusText ? ` ${statusText} - ` : ' '}${errorDetails}`;
    }
    return `Failed to get order details due to network error: ${error.message || 'Unknown error'}`;
};
export const parseFetchivalErrorWithOrder = async (error) => {
    if (error.response) {
        const { status, statusText, errorDetails, errorData } = await extractErrorDetails(error);
        return {
            message: `${status}:${statusText ? ` ${statusText} - ` : ' '}${errorDetails}`,
            orderId: errorData.orderId,
        };
    }
    return {
        message: `Failed to get order details due to network error: ${error.message || 'Unknown error'}`,
        orderId: '',
    };
};
export const isAssetPairExchangeable = ({ from, to, assetSources, }) => {
    return assetSources.some((source) => {
        const sourceAssetIds = source.assetIds;
        return sourceAssetIds.includes(from) && sourceAssetIds.includes(to);
    });
};
